export default __webpack_public_path__ + "static/media/icon_btn_earth.7b996d8b.svg";